// extracted by mini-css-extract-plugin
export default {"container":"UiHandlerStatus_container_bUh3J","success":"UiHandlerStatus_success_FQoJX","icon":"UiHandlerStatus_icon_dtth2","message":"UiHandlerStatus_message_ZicLF"};